import { useEffect } from "react";
import { connect } from "react-redux";
import { tokenize } from "../../actions/auth";
import { useNavigate } from "react-router-dom";
import { sameOriginPath } from "../../utils/auth/navigation";

const Tokenize = ({ tokenize }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const persistData = async () => {
            const params = new URLSearchParams(window.location.search);
            const token = params.get("t");
            const instance = params.get("i");
            const secure = params.get("s") === "1";
            const address = params.get("a");
            const port = params.get("p");
            const next = sameOriginPath(params.get("next"));

            if (!token || !instance || !address) return;
            const url = `http${secure ? "s" : ""}://${address}${port ? `:${port}` : ""}/`;

            try {
                if (await tokenize(instance, token, url)) {
                    navigate(next || "/dashboard", { replace: true });
                }
            } catch (err) {
                console.error(err);
            }
        };

        persistData();
    }, [tokenize, navigate]);

    return null;
};

export default connect(null, { tokenize })(Tokenize);
